import { ContractFeeFrequency } from './contract-fee-frequency.interface';
import contractFeeFrequencyService from './contract-fee-frequency.service';

export interface ContractFeeFrequencyState {
   contractFeeFrequencies: Array<ContractFeeFrequency>;
}

const state: ContractFeeFrequencyState = {
   contractFeeFrequencies: [],
};

const getters = {
   contractFeeFrequencies(state: ContractFeeFrequencyState) {
      return state.contractFeeFrequencies;
   },
};

const mutations = {
   SET_CONTRACT_FEE_FREQUENCIES(state: ContractFeeFrequencyState, contractFeeFrequencies: Array<ContractFeeFrequency>) {
      state.contractFeeFrequencies = contractFeeFrequencies;
   },
};

const actions = {
   async getContractFeeFrequencies(context: any) {
      return await contractFeeFrequencyService.getContractFeeFrequencies().then((contractFeeFrequencies) => {
         context.commit('SET_CONTRACT_FEE_FREQUENCIES', contractFeeFrequencies);
         return contractFeeFrequencies;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
